import { Link } from "react-router-dom";
import { SectionContainer } from "@/components/shared/SectionContainer";

export function NotFoundPage() {
  return (
    <SectionContainer className="text-center">
      <p className="font-serif text-9xl text-primary">404</p>
      <h1 className="mt-4 font-serif text-3xl">This page is off the map.</h1>
      <p className="mx-auto mt-3 max-w-md text-muted-foreground">
        The link you followed may be broken, or the page may have been moved. Let&apos;s
        get you back somewhere useful.
      </p>
      <div className="mt-6 flex justify-center gap-3">
        <Link to="/" className="btn" >
          ← Back home
        </Link>
        <Link to="/projects" className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground">
          View projects
        </Link>
      </div>
    </SectionContainer>
  );
}
